import React, { Component } from 'react';
import API from '../API';
import store from '../store';
import { R } from '../routes';


class Logout extends Component {
	componentDidMount() {
		API.post("/a/signout");
		store.dispatch_value("me", null);
		R.replace("/");
	}

	render() {
		return <div>...</div>;
	}

}

export default Logout;



// WEBPACK FOOTER //
// ./src/p/Logout.js